<template>
	<div class="container">
		<div class="circle-container">
			<div class="outer-circle">
				<div class="inner-circle"><img src="../assets/images/youtube_logo.png" alt="logo"></div>
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	
}
</script>

<style scoped>
.circle-container {
	display: flex;
	justify-content: center;
	align-content: center;
	flex-direction: column;
	width: 100%;
}

.outer-circle {
	position: relative;
	align-self: center;
	height: 200px;
	width: 200px;
	background: linear-gradient(#14ffe9, #ffeb3b, #ff00e0);
	border-radius: 50%;
	animation: rotate 1.5s linear infinite;
}

.outer-circle span {
	position: absolute;
	height: 200px;
	width: 200px;
	left: 0;
	background: linear-gradient(#14ffe9, #ffeb3b, #ff00e0);
	border-radius: 50%;
}

span:nth-child(1) {
  filter: blur(5px);
}

span:nth-child(2) {
  filter: blur(10px);
}

span:nth-child(3) {
  filter: blur(25px);
}

span:nth-child(4) {
  filter: blur(150px);
}

.inner-circle {
	height: 180px;
	width: 180px;
	position: absolute;
	background: black;
	top: 10px;
	left: 10px;
	border-radius: 50%;
	z-index: 2
}

@keyframes rotate {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}

img {
	position: relative;
	width: 100px;
	top: 40px;
	
}
</style>